import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { useAuthStore } from "../../store/authStore";
import { authService } from "../../services/apiService";

/**
 * Mounted once per app boot. Calls POST /verifyMe to refresh the user +
 * permissions from the server so role/permission/centre changes apply on the
 * next load, and logs out users who were deactivated or deleted.
 */
export default function Layout() {
  const token = useAuthStore((s) => s.token);
  const setUser = useAuthStore((s) => s.setUser);
  const setPermissions = useAuthStore((s) => s.setPermissions);
  const logout = useAuthStore((s) => s.logout);
  const verified = useRef(false);

  useEffect(() => {
    if (verified.current) return;
    if (!token) return;
    verified.current = true;

    authService
      .verifyMe()
      .then((res) => {
        if (res?.success && res.data) {
          if (res.data.user) setUser(res.data.user);
          setPermissions(res.data.permissions || []);
        } else if (res && res.success === false) {
          logout();
          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
        }
      })
      .catch(() => {
        /* axios interceptor handles 401/403 logout */
      });
  }, [token, setUser, setPermissions, logout]);

  return (
    <>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100">
        <Header />
        <div className="body flex-grow-1">
          <div className="container-fluid px-4">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
